import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { SITE_NAME } from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

const NAV = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/#features', label: 'Features' },
  { to: '/#getting-started', label: 'Getting Started' },
  { to: '/#faq', label: 'FAQ' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="header">
      <div className="shell header__inner">
        <Link to="/" className="header__brand" onClick={() => setOpen(false)}>
          <span className="header__mark" aria-hidden="true" />
          <span>
            <strong>{SITE_NAME}</strong>
            <small>Help Desk</small>
          </span>
        </Link>

        <nav className="header__nav" aria-label="Main navigation">
          {NAV.map((item) => (
            <Link key={item.label} to={item.to} className="header__link">
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="header__actions">
          <button type="button" className="btn btn--primary btn--sm" onClick={openZohoChat}>
            Chat Now
          </button>
        </div>

        <button
          type="button"
          className="header__toggle"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      {open ? (
        <nav className="header__mobile" aria-label="Mobile navigation">
          {NAV.map((item) => (
            <Link key={item.label} to={item.to} className="header__mobile-link" onClick={() => setOpen(false)}>
              {item.label}
            </Link>
          ))}
          <button type="button" className="btn btn--primary" onClick={openZohoChat}>
            Chat Now
          </button>
        </nav>
      ) : null}
    </header>
  );
}
